import { createActions, createReducer } from 'reduxsauce';

export const INITIAL_STATE = {
  fetching: false,
  fetched: false,
  error: null,
  data: [],
};

const { Types, Creators } = createActions(
  {
    getPointsBalances: [],
    getPointsBalancesRequest: [],
    getPointsBalancesSuccess: ['data'],
    getPointsBalancesFailure: ['error'],
  },
  { prefix: 'cb/admin/pointsManager/pointsBalancesTransactions' },
);

export { Types as types, Creators as actions };

export const request = (state) => ({
  ...state,
  fetching: true,
});

export const success = (_, action) => {
  const { data } = action;  
  return {
    ...INITIAL_STATE,
    fetched: true,
    data,
  };
};

export const failure = (_, action) => {
  const { error } = action;
  return {
    ...INITIAL_STATE,
    fetched: true,
    error,
  };
};

export const HANDLERS = {
  [Types.GET_POINTS_BALANCES_REQUEST]: request,
  [Types.GET_POINTS_BALANCES_SUCCESS]: success,
  [Types.GET_POINTS_BALANCES_FAILURE]: failure,
};

const pointsBalancesReducer = createReducer(INITIAL_STATE, HANDLERS);

export default pointsBalancesReducer